<style lang="sass" scoped>
  
</style>
<template>
  <div class="container-fluid col-l-11 col-m-12 col-12">
    <div class="hdr"><h2>Song Registration</h2></div>
    <div class="form-wrapper gdwrapper">
      <div class="col-l-3 col-m-6 col-12">
        <button @click="showSongReg">Registration Info</button>
      </div>
      <div class="col-l-3 col-m-6 col-12">
        <button @click="showPublishers">Pubs</button>
      </div>
      <div class="col-l-3 col-m-6 col-12">
        <button @click="showWriters">Writers</button>
      </div>
      <div class="col-l-3 col-m-6 col-12">
        <button @click="showSummary">Summary</button>
      </div>
      <div v-if="route.name === 'pubs'" class="col-l-12 col-l-m col-12 gdwrapper">
        <div class="col-l-6 col-m-6 col-6">
          <button @click="addNewPublisher">Add Publisher</button>
        </div>
        <div class="col-l-6 col-m-6 col-6">
          <button @click="removeNewPublisher">Remove Publisher</button>
        </div>
      </div>
      <div v-if="(route.name === 'wrtrs')" class="col-l-12 col-l-m col-12 gdwrapper">
        <div class="col-l-6 col-m-6 col-6">
          <button @click="addNewWriter">Add Writer</button>
        </div>
        <div class="col-l-6 col-m-6 col-6">
          <button @click="removeNewWriter">Remove Writer</button>
        </div>
      </div>
      <form class="col-l-12 col-m-12 col-12 gdwrapper" @submit.prevent="handleSubmit">
        <RouterView v-model:songRegistration="songRegistration" />
      </form>
    </div>
    <div class="stats"><span v-if="songRegistration"> Publishers: {{ songRegistration.publisherInfo.length }} | Writers: {{ songRegistration.writerInfo.length }}</span></div>
    <div class="ftr">Song Registration Page - RS_TL</div>
  </div>
  <div class="col-l-1"></div>
</template>
<script setup>
  import SongRegistration, { PublisherInfo, WriterInfo} from '../../../models/SongRegistration.ts'
  import router from '@/libs/routes.ts';
  import { useRoute } from 'vue-router';
  import { ref } from 'vue';
  import { restapi } from '@/libs/restapi'
  import { useUserStore } from '@/libs/stores.ts';
  const auth = useUserStore();
  const route = useRoute();
  const songRegistration = ref(new SongRegistration(auth.user.sub + '#SongReg'));
  // provide('songRegistration', songRegistration);
  const handleSubmit = async () => {
    // console.log('for items:', songRegistration.value);
    const response = await restapi.putASongRegItemsA(songRegistration.value);
    // console.log(response);
    if(response){
      auth.songRegistrations = undefined;
      router.push({name: 'srsummary'});
    }
    return false;
  }
  const showSongReg = () => {
    router.push({name: 'reginfo'})
  }
  const showPublishers = () => {
    router.push({name: 'pubs'})
  }
  const showWriters = () => {
    router.push({name: 'wrtrs'})
  }
  const showSummary = () => {
    router.push({name: 'summary'})
  }
  const addNewPublisher = () => {
    if(songRegistration.value.publisherInfo) {
      songRegistration.value.publisherInfo.push(new PublisherInfo())
    }
  }
  function removeNewPublisher(index) {
    // console.log(index)
    songRegistration.value.publisherInfo.splice(index, 1)
  }
  const addNewWriter = () => {
    if(songRegistration.value.writerInfo) {
      songRegistration.value.writerInfo.push(new WriterInfo())
    }
  }
  function removeNewWriter(index) {
    // console.log(index)
    songRegistration.value.writerInfo.splice(index, 1)
  }
</script>
<style lang="css" scoped>
  .data-entry-container {
    display: grid;
    grid-template: 
      "hd hd hd hd hd" 20vh
      "f1 f1 f1 f2 f2" 20vh
      "bd bd bd bd bd" auto
      "sts sts sts sts sts" 5vh / 1fr 1fr 2fr 1fr 1fr
    ;
  }
  .hdr {
    grid-area: hd;
  }
  .bdy {
    grid-area: sts;
  }
  .form-wrapper {
    grid-area: bd;
  }
  .ftr {
    grid-area: f2;
  }
  .stats {
    grid-area: f1;
  }

</style>
